import { NotFoundView } from '@/components/app/NotFoundView';

export function NotFoundPage() {
    return <NotFoundView />;
}
